// extracted by mini-css-extract-plugin
export default {"stepTracker":"dashboard-informationarea_stepTracker__tgnXV"};